type CountryPhoneInfo = {
    placeholder: string;
    pattern: string;
    length: number;
};

export const defaultCountryCode: CountryPhoneInfo = {
    placeholder: "0X XX XX XX XX",
    pattern: "0[1-9]\\d{8}",
    length: 10,
};

export const countriesPhoneCode: Record<string, CountryPhoneInfo> = {
    TN: {
        placeholder: "0X XX XX XX",
        pattern: "[2-5-9]\\d{7}",
        length: 8,
    },
    FR: {
        placeholder: "0X XX XX XX XX",
        pattern: "0[1-9]\\d{8}",
        length: 10,
    },
    US: {
        placeholder: "(XXX) XXX-XXXX",
        pattern: "\\d{10}",
        length: 10,
    },
    DE: {
        placeholder: "0XX XXXXXXXX",
        pattern: "0\\d{10,11}",
        length: 10,
    },
    GB: {
        placeholder: "0XXXX XXXXXX",
        pattern: "0\\d{9,10}",
        length: 10,
    },
    IT: {
        placeholder: "0X XXX XXXX",
        pattern: "0\\d{9,10}",
        length: 10,
    },
    ES: {
        placeholder: "6XX XXX XXX",
        pattern: "[6-9]\\d{8}",
        length: 9,
    },
    PT: {
        placeholder: "9XX XXX XXX",
        pattern: "9\\d{8}",
        length: 9,
    },
    NL: {
        placeholder: "0X XXX XXXX",
        pattern: "0\\d{9}",
        length: 10,
    },
    BE: {
        placeholder: "04XX XX XX XX",
        pattern: "0\\d{8,9}",
        length: 9,
    },
    CH: {
        placeholder: "0XX XXX XX XX",
        pattern: "0\\d{9}",
        length: 10,
    },
    AT: {
        placeholder: "0XXX XXX XXX",
        pattern: "0\\d{9,10}",
        length: 10,
    },
    SE: {
        placeholder: "07X XXX XXXX",
        pattern: "0\\d{9}",
        length: 10,
    },
    NO: {
        placeholder: "4XX XX XXX",
        pattern: "[4-9]\\d{7}",
        length: 8,
    },
    DK: {
        placeholder: "XX XX XX XX",
        pattern: "\\d{8}",
        length: 8,
    },
    FI: {
        placeholder: "04X XXX XXXX",
        pattern: "0\\d{9,10}",
        length: 10,
    },
    GR: {
        placeholder: "69X XXX XXXX",
        pattern: "\\d{10}",
        length: 10,
    },
    IE: {
        placeholder: "08X XXX XXXX",
        pattern: "0\\d{9}",
        length: 10,
    },
    PL: {
        placeholder: "XXX XXX XXX",
        pattern: "\\d{9}",
        length: 9,
    },
    CZ: {
        placeholder: "XXX XXX XXX",
        pattern: "\\d{9}",
        length: 9,
    },
    SK: {
        placeholder: "09X XXX XXX",
        pattern: "0\\d{8}",
        length: 9,
    },
    RO: {
        placeholder: "07X XXX XXX",
        pattern: "0\\d{9}",
        length: 10,
    },
    HU: {
        placeholder: "(06) XX XXX XXX",
        pattern: "06\\d{8}",
        length: 10,
    },
    BG: {
        placeholder: "08X XXX XXX",
        pattern: "0\\d{8}",
        length: 9,
    },
    SI: {
        placeholder: "0X XXX XXX",
        pattern: "0\\d{8}",
        length: 9,
    },
    HR: {
        placeholder: "09X XXX XXX",
        pattern: "0\\d{8}",
        length: 9,
    },
    AL: {
        placeholder: "06X XXX XXX",
        pattern: "0\\d{8}",
        length: 9,
    },
    TR: {
        placeholder: "05XX XXX XXXX",
        pattern: "0\\d{10}",
        length: 11,
    },
    MA: {
        placeholder: "0X XX XX XX XX",
        pattern: "0[5-7]\\d{8}",
        length: 10,
    },
    DZ: {
        placeholder: "0X XX XX XX XX",
        pattern: "0[5-7]\\d{8}",
        length: 10,
    },
};
